








































































import { Component, Mixins, Prop } from "vue-property-decorator";
import { mapState, mapGetters } from "vuex";
import _ from "lodash";

// Mixins
import RequestPromises from "@/mixins/requestPromises";

// Enums
import { DataModules } from "@/store/modules/data";
import { CategorySlug, DocsSlugs } from "@/data/enums/docs";

// Types
import { IState } from "@/store";
import { IEntityCategory } from "@/models/settings";

@Component({
  components: {
    "dynamic-settings": () =>
      import("@/components/app/admin/settings/dynamicSettings.vue"),
    "predefined-settings": () =>
      import("@/components/app/admin/settings/predefinedSettings.vue")
  },
  computed: {
    ...mapState({
      categoryScope(state: IState, getters) {
        return getters[`data/${this.dataModule}/categoryScope`](
          this.entity,
          this.code
        );
      },
      category(state: IState, getters) {
        return getters[`data/single`]({
          storeModule: this.dataModule,
          scope: this.categoryScope
        });
      }
    }),
    ...mapGetters({
      isOrgMode: "brand/isMultibrand"
    })
  }
})
export default class AdminSettingsDynamicCategory extends Mixins(
  RequestPromises
) {
  // Getters

  public categoryScope!: string;
  public category!: IEntityCategory;
  public isOrgMode!: boolean;

  // Refs

  public $refs!: {
    dynamicSettings: HTMLFormElement;
    predefinedSettings: HTMLFormElement;
  };

  // Props

  @Prop({ default: null })
  public settingsCode!: string;

  @Prop({ default: true })
  public dynamicShowOnOrg!: boolean;

  @Prop({ default: true })
  public dynamicShowOnBrand!: boolean;

  @Prop({ default: true })
  public predefinedShowOnOrg!: boolean;

  @Prop({ default: true })
  public predefinedShowOnBrand!: boolean;

  // Variables
  public dataModule: string = DataModules.SETTINGS_CATEGORIES;

  public contentIsAvailable = this.$userCan("show_settings");
  public canManageBrand = this.$userCan("update_brand");

  public isInitialLoading = false;
  public isReloading = false;
  public requestError = false;

  public isProcessing = false;
  public entity = "brand";
  public code = "";

  public dynamicSettingsErrors = false;
  public dynamicSettingsChanged = false;
  public predefinedSettingsErrors = false;
  public predefinedSettingsChanged = false;

  public dynamicSettingsLoading = true;
  public predefinedSettingsLoading = true;

  public created() {
    if (!this.contentIsAvailable) return;

    this.code = this.$route.params.settingId || this.settingsCode;

    if (!this.isOrgMode) {
      this.isInitialLoading = true;
      this.loadData();
    }

    this.setDocs();
  }

  public async loadData() {
    try {
      await this.getCategory();
      this.requestError = false;
    } catch (error) {
      this.$store.dispatch("api/handleError", error);
      this.requestError = true;
    } finally {
      this.isInitialLoading = false;
      this.isReloading = false;
    }
  }

  public reloadData() {
    this.isReloading = true;
    this.loadData();
  }

  public getCategory() {
    return this.$store.dispatch(`data/${this.dataModule}/getCategory`, {
      entity: this.entity,
      code: this.code,
      scope: this.categoryScope,
      vm: this
    });
  }

  public async save() {
    if (this.dynamicSettingsErrors || this.predefinedSettingsErrors) return;

    this.isProcessing = true;

    try {
      const validations = await Promise.all([
        this.$refs["predefinedSettings"].validate(),
        this.$refs["dynamicSettings"].validate()
      ]);

      if (
        this.$_.filter(validations, validation => validation === false).length
      ) {
        throw new Error(this.$t("_sentence.form_is_not_valid") as string);
      }

      await Promise.all([
        this.$refs["predefinedSettings"].save(),
        this.$refs["dynamicSettings"].save()
      ]);

      this.$store.dispatch("toast/show", {
        message: this.$t("_.object_successfully_updated", {
          object: this.$t("_.brand")
        })
      });
    } catch (error) {
      this.$store.dispatch("api/handleError", error);
    } finally {
      this.isProcessing = false;
    }
  }

  public dynamicSettingsHasErrors(value: boolean) {
    this.dynamicSettingsErrors = value;
  }

  public dynamicSettingsAreChanged(value: boolean) {
    this.dynamicSettingsChanged = value;
  }

  public dynamicSettingsAreLoading(value: boolean) {
    this.dynamicSettingsLoading = value;
  }

  public predefinedSettingsHasErrors(value: boolean) {
    this.predefinedSettingsErrors = value;
  }

  public predefinedSettingsAreChanged(value: boolean) {
    this.predefinedSettingsChanged = value;
  }

  public predefinedSettingsAreLoading(value: boolean) {
    this.predefinedSettingsLoading = value;
  }

  public get formCanBeSent() {
    return (
      !this.dynamicSettingsLoading &&
      !this.predefinedSettingsLoading &&
      (this.dynamicSettingsChanged || this.predefinedSettingsChanged)
    );
  }

  public get buttonIsDisabled() {
    return this.$_.get(this.$refs, "dynamicSettings")
      ? this.$_.get(this.$refs, "dynamicSettings").isSaveButtonDisabled()
      : true;
  }

  public get title() {
    return this.$_.get(this.category, "name", this.$t(this.$route.meta.title));
  }

  public revertToInitialState() {
    this.$refs["predefinedSettings"].revertToInitialState();
    this.$refs["dynamicSettings"].revertToInitialState();
  }

  public beforeDestroy() {
    if (this.contentIsAvailable) {
      this.$store.dispatch("data/bin", {
        storeModule: this.dataModule,
        scope: this.categoryScope,
        vm: this
      });
    }
  }

  public setDocs() {
    let pageSlug = this.$route.params.settingId
      ? this.$route.params.settingId
      : "";
    pageSlug = _.replace(pageSlug, "-", "_").toUpperCase();
    this.$route.meta.categorySlug = CategorySlug[pageSlug];
    this.$route.meta.docsSlugs = [DocsSlugs[pageSlug]];
  }

  public get dynamicIsVisible() {
    if (this.dynamicShowOnBrand && !this.isOrgMode) return true;
    if (this.dynamicShowOnOrg && this.isOrgMode) return true;

    return false;
  }
}
